// Modül 13-14 - Uçak Tipleri & Acil Durumlar - İnteraktif İçerikler

const cabinCrewContentsM13M14Interactive = {
  // ==================== MODÜL 13: UÇAK TİPLERİ ====================
  'CM-M13-U1-L1': {
    lesson_id: 'CM-M13-U1-L1',
    title: 'Airbus A320 Ailesi',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '✈️ Airbus A320 Ailesi',
      intro: 'Dünyanın en popüler dar gövde uçakları',
      facts: [
        { icon: 'A318', title: 'A318', text: 'En kısa: 107 yolcu' },
        { icon: 'A319', title: 'A319', text: 'Kısa: 124 yolcu' },
        { icon: 'A320', title: 'A320', text: 'Standart: 150 yolcu' },
        { icon: 'A321', title: 'A321', text: 'Uzun: 185 yolcu' },
        { icon: 'NEO', title: 'NEO', text: 'New Engine Option - yakıt tasarruflu' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'A320 ailesinde en uzun uçak?',
        options: [
          { text: 'A318', isCorrect: false, feedback: '❌ A318 en kısa!' },
          { text: 'A320', isCorrect: false, feedback: '❌ A320 standart boy' },
          { text: 'A321', isCorrect: true, feedback: '✅ A321 = 185 yolcu!' }
        ]
      }
    }
  },

  'CM-M13-U1-L2': {
    lesson_id: 'CM-M13-U1-L2',
    title: 'Airbus Geniş Gövde',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🟦 Airbus Geniş Gövde',
      intro: 'Uzun mesafe uçakları',
      categories: [
        { icon: 'A330', title: 'A330', examples: '250-440 yolcu', desc: 'İki motorlu, orta mesafe' },
        { icon: 'A350', title: 'A350', examples: '300-440 yolcu', desc: 'En yeni, verimli' },
        { icon: 'A380', title: 'A380', examples: '500-850 yolcu', desc: 'Dünyanın en büyüğü!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Dünyanın en büyük yolcu uçağı?',
        options: [
          { text: 'Boeing 747', isCorrect: false, feedback: '❌ 747 eskiden birinciydi!' },
          { text: 'Airbus A380', isCorrect: true, feedback: '✅ A380 = Çift katlı dev!' },
          { text: 'Airbus A350', isCorrect: false, feedback: '❌ A350 daha küçük' }
        ]
      }
    }
  },

  'CM-M13-U2-L1': {
    lesson_id: 'CM-M13-U2-L1',
    title: 'Boeing 737 Ailesi',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '✈️ Boeing 737 Ailesi',
      intro: 'Dünyanın en çok satan uçağı!',
      facts: [
        { icon: '-700', title: '737-700', text: 'Kısa: 126 yolcu' },
        { icon: '-800', title: '737-800', text: 'Standart: 162 yolcu (en popüler)' },
        { icon: '-900', title: '737-900', text: 'Uzun: 177 yolcu' },
        { icon: 'MAX', title: '737 MAX', text: 'Yeni nesil, daha verimli' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En popüler 737 versiyonu?',
        options: [
          { text: '737-700', isCorrect: false, feedback: '❌ Daha küçük versiyon' },
          { text: '737-800', isCorrect: true, feedback: '✅ 162 yolcu, en yaygın!' },
          { text: '737-900', isCorrect: false, feedback: '❌ Daha az yaygın' }
        ]
      }
    }
  },

  'CM-M13-U2-L2': {
    lesson_id: 'CM-M13-U2-L2',
    title: 'Boeing Geniş Gövde',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🟦 Boeing Geniş Gövde',
      intro: 'Uzun mesafe Boeing uçakları',
      categories: [
        { icon: '777', title: 'Boeing 777', examples: '300-400 yolcu', desc: 'İki motorlu dev' },
        { icon: '787', title: 'Boeing 787 Dreamliner', examples: '250-330 yolcu', desc: 'Karbon fiber, verimli' },
        { icon: '747', title: 'Boeing 747', examples: '400-500 yolcu', desc: 'Jumbo Jet, ikona' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: '"Dreamliner" hangi uçak?',
        options: [
          { text: 'Boeing 777', isCorrect: false, feedback: '❌ 777 = Triple Seven' },
          { text: 'Boeing 787', isCorrect: true, feedback: '✅ 787 = Dreamliner!' },
          { text: 'Boeing 747', isCorrect: false, feedback: '❌ 747 = Jumbo Jet' }
        ]
      }
    }
  },

  'CM-M13-U3-L4': {
    lesson_id: 'CM-M13-U3-L4',
    title: '🎮 Kabin Eşleştirme',
    type: 'matching',
    duration: 3,
    xp: 45,
    matching: {
      instruction: 'Kabin terimini açıklamasıyla eşleştir',
      pairs: [
        { id: 1, left: 'Galley', right: 'Mutfak alanı' },
        { id: 2, left: 'Lavatory', right: 'Tuvalet' },
        { id: 3, left: 'Overhead bin', right: 'Baş üstü bagaj dolabı' },
        { id: 4, left: 'Jump seat', right: 'Kabin ekibi koltuğu' },
        { id: 5, left: 'Exit row', right: 'Acil çıkış sırası' }
      ]
    }
  },

  'CM-M13-U4-L2': {
    lesson_id: 'CM-M13-U4-L2',
    title: '⚡ Uçak Tanıma Yarışı',
    type: 'timerace',
    duration: 3,
    xp: 55,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'Çift katlı dev uçak?', options: ['A350', 'A380', 'B787', 'B777'], correct: 1 },
        { q: 'Dreamliner hangi uçak?', options: ['A350', 'A380', 'B787', 'B777'], correct: 2 },
        { q: 'En çok satan uçak ailesi?', options: ['A320', 'A380', 'B737', 'B747'], correct: 2 },
        { q: 'Jumbo Jet?', options: ['B777', 'B787', 'B747', 'A380'], correct: 2 },
        { q: 'A320 ailesinde en uzun?', options: ['A318', 'A319', 'A320', 'A321'], correct: 3 },
        { q: 'NEO ne demek?', options: ['New Engine Option', 'Next Evolution', 'New Era', 'No Emission'], correct: 0 }
      ]
    }
  },

  'CM-M13-U4-L3': {
    lesson_id: 'CM-M13-U4-L3',
    title: '🎮 Doğru/Yanlış: Uçaklar',
    type: 'truefalse',
    duration: 3,
    xp: 40,
    truefalse: {
      statements: [
        { statement: 'A380 dünyanın en büyük yolcu uçağıdır.', isTrue: true, explanation: '✅ 500-850 yolcu kapasiteli!' },
        { statement: 'Boeing 787\'ye Jumbo Jet denir.', isTrue: false, explanation: '❌ Jumbo Jet = 747, Dreamliner = 787!' },
        { statement: 'A321, A320 ailesinde en uzun uçaktır.', isTrue: true, explanation: '✅ 185 yolcu kapasiteli!' },
        { statement: '737-800 en popüler 737 versiyonudur.', isTrue: true, explanation: '✅ Dünyanın en yaygın uçağı!' },
        { statement: 'Airbus uçakları sadece Avrupa\'da kullanılır.', isTrue: false, explanation: '❌ Dünya genelinde kullanılır!' }
      ]
    }
  },

  // ==================== M13 EKSİK DERSLER ====================
  'CM-M13-U1-L3': {
    lesson_id: 'CM-M13-U1-L3',
    title: '⚡ Dar Gövde Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'A320 kaç koridorlu?', options: ['1', '2', '3', '0'], correct: 0 },
        { q: 'B737 MAX motor adı?', options: ['CFM56', 'LEAP', 'GE90', 'PW1100'], correct: 1 },
        { q: 'Dar gövde genellikle kaç saat?', options: ['1-5', '6-10', '10-15', '15+'], correct: 0 },
        { q: 'A320neo ne demek?', options: ['New Engine', 'New Edition', 'New Era', 'Neo Model'], correct: 0 }
      ]
    }
  },

  'CM-M13-U2-L3': {
    lesson_id: 'CM-M13-U2-L3',
    title: '⚡ Geniş Gövde Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'A380 kaç katlı?', options: ['1', '2', '3', '4'], correct: 1 },
        { q: 'B787 lakabı?', options: ['Jumbo', 'Dreamliner', 'Queen', 'Star'], correct: 1 },
        { q: 'A350 gövde malzemesi?', options: ['Alüminyum', 'Karbon fiber', 'Çelik', 'Titanyum'], correct: 1 },
        { q: 'Geniş gövde koridor sayısı?', options: ['1', '2', '3', '4'], correct: 1 }
      ]
    }
  },

  'CM-M13-U3-L1': {
    lesson_id: 'CM-M13-U3-L1',
    title: 'Kabin Sınıfları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '💺 Kabin Sınıfları',
      intro: 'Farklı yolcu sınıfları ve özellikleri',
      categories: [
        { icon: '👑', title: 'First Class', examples: 'Suit, yatak, şef', desc: 'En lüks' },
        { icon: '💼', title: 'Business', examples: 'Flat yatak, premium', desc: 'İş seyahati' },
        { icon: '➕', title: 'Premium Economy', examples: 'Geniş koltuk', desc: 'Orta segment' },
        { icon: '💺', title: 'Economy', examples: 'Standart', desc: 'Çoğunluk' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En lüks sınıf?',
        options: [
          { text: 'Business', isCorrect: false, feedback: '❌ İkinci lüks!' },
          { text: 'First Class', isCorrect: true, feedback: '✅ Suite ve özel hizmet!' },
          { text: 'Premium Economy', isCorrect: false, feedback: '❌ Orta segment!' }
        ]
      }
    }
  },

  'CM-M13-U3-L2': {
    lesson_id: 'CM-M13-U3-L2',
    title: 'Galley ve Lavabo',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🍽️ Galley ve Lavabo',
      intro: 'Uçak mutfağı ve tuvalet alanları',
      facts: [
        { icon: '🍽️', title: 'Galley', text: 'Yemek hazırlama alanı' },
        { icon: '🚿', title: 'Lavatory', text: 'Tuvalet' },
        { icon: '🧊', title: 'Trolley', text: 'Servis arabaları' },
        { icon: '♻️', title: 'Atık', text: 'Ayrıştırma önemli' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Galley nedir?',
        options: [
          { text: 'Kokpit', isCorrect: false, feedback: '❌ Kokpit pilotların alanı!' },
          { text: 'Uçak mutfağı', isCorrect: true, feedback: '✅ Yemek ve içecek hazırlama!' },
          { text: 'Bagaj bölümü', isCorrect: false, feedback: '❌ Cargo hold farklı!' }
        ]
      }
    }
  },

  'CM-M13-U3-L3': {
    lesson_id: 'CM-M13-U3-L3',
    title: '🎮 Kabin Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      instruction: 'Terimleri açıklamalarıyla eşleştir',
      pairs: [
        { id: 1, left: 'Galley', right: 'Uçak mutfağı' },
        { id: 2, left: 'Lavatory', right: 'Tuvalet' },
        { id: 3, left: 'Overhead Bin', right: 'Üst bagaj dolabı' },
        { id: 4, left: 'Jump Seat', right: 'Ekip koltuğu' }
      ]
    }
  },

  'CM-M13-U4-L1': {
    lesson_id: 'CM-M13-U4-L1',
    title: 'Uçak Karşılaştırma',
    type: 'interactive',
    duration: 5,
    xp: 30,
    content: {
      title: '⚖️ Airbus vs Boeing',
      intro: 'İki dev üreticinin karşılaştırması',
      categories: [
        { icon: '🇪🇺', title: 'Airbus', examples: 'Avrupa - Toulouse', desc: 'Side stick' },
        { icon: '🇺🇸', title: 'Boeing', examples: 'ABD - Seattle', desc: 'Yoke (direksiyon)' },
        { icon: '💡', title: 'Fark', examples: 'Kontrol sistemleri', desc: 'Fly-by-wire vs mekanik' },
        { icon: '🌍', title: 'Pazar', examples: 'Yaklaşık %50-%50', desc: 'Dengeli rekabet' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Airbus kokpitinde ne var?',
        options: [
          { text: 'Yoke (direksiyon)', isCorrect: false, feedback: '❌ Yoke Boeing\'de!' },
          { text: 'Side stick (yan kumanda)', isCorrect: true, feedback: '✅ Fly-by-wire sistem!' },
          { text: 'Düğme yok', isCorrect: false, feedback: '❌ Bol düğme var!' }
        ]
      }
    }
  },

  'CM-M13-U5-L1': {
    lesson_id: 'CM-M13-U5-L1',
    title: '🎓 Uçak Tipleri Final',
    type: 'exam',
    duration: 10,
    xp: 100,
    exam: {
      questions: [
        { q: 'A320 kaç koridorlu?', options: ['1', '2', '3', '0'], correct: 0 },
        { q: 'B787 lakabı?', options: ['Jumbo', 'Dreamliner', 'Queen', 'Star'], correct: 1 },
        { q: 'En büyük yolcu uçağı?', options: ['B747', 'A380', 'A350', 'B777'], correct: 1 },
        { q: 'Galley nedir?', options: ['Kokpit', 'Mutfak', 'Tuvalet', 'Kargo'], correct: 1 },
        { q: 'Airbus kontrol?', options: ['Yoke', 'Side stick', 'Joystick', 'Düğme'], correct: 1 },
        { q: 'First Class özelliği?', options: ['Standart', 'Suite yatak', 'Ayakta', 'Ortak'], correct: 1 },
        { q: 'neo ne demek?', options: ['Yeni', 'New Engine', 'Next', 'Neo Era'], correct: 1 },
        { q: 'Jumbo Jet hangi uçak?', options: ['B737', 'B747', 'B787', 'B777'], correct: 1 }
      ]
    }
  },

  // ==================== MODÜL 14: ACİL DURUM PROSEDÜRLERİ ====================
  'CM-M14-U1-L1': {
    lesson_id: 'CM-M14-U1-L1',
    title: 'Tahliye Türleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🚨 Acil Tahliye Türleri',
      intro: 'Tahliye durumları ve farkları',
      categories: [
        { icon: '🟢', title: 'Planlı Tahliye', examples: 'Hazırlık zamanı var', desc: 'Brace position, brifing' },
        { icon: '🔴', title: 'Plansız Tahliye', examples: 'Anında müdahale', desc: 'Yangın, ani tehlike' },
        { icon: '🔵', title: 'Kara Tahliyesi', examples: 'Kuru zemin', desc: 'Slide kullanımı' },
        { icon: '🟡', title: 'Su Tahliyesi', examples: 'Ditching', desc: 'Raft ve can yeleği' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Plansız tahliyede ne yapılır?',
        options: [
          { text: 'Yolculara brifing ver', isCorrect: false, feedback: '❌ Zaman yok!' },
          { text: 'Anında tahliye komutu ver', isCorrect: true, feedback: '✅ Derhal aksiyon!' },
          { text: 'Kaptana sor', isCorrect: false, feedback: '❌ Hayati tehlike varsa beklenilmez!' }
        ]
      }
    }
  },

  'CM-M14-U1-L4': {
    lesson_id: 'CM-M14-U1-L4',
    title: '🎮 Tahliye Sıralaması',
    type: 'dragdrop',
    duration: 3,
    xp: 45,
    dragdrop: {
      instruction: 'Planlı tahliye adımlarını sırala',
      items: [
        { text: '📢 Kaptan bildirisi al', order: 1 },
        { text: '🗣️ Brace position komutu', order: 2 },
        { text: '✈️ İniş ve durma', order: 3 },
        { text: '🚪 Kapı değerlendirme', order: 4 },
        { text: '🚨 Slide açma / Tahliye', order: 5 },
        { text: '🆘 Yolcu sayımı', order: 6 }
      ]
    }
  },

  'CM-M14-U2-L1': {
    lesson_id: 'CM-M14-U2-L1',
    title: 'Yangın Tipleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🔥 Uçakta Yangın Sınıfları',
      intro: 'Farklı yangın tipleri ve söndürücüleri',
      facts: [
        { icon: 'A', title: 'Sınıf A', text: 'Kağıt, kumaş, plastik - SU veya HALON' },
        { icon: 'B', title: 'Sınıf B', text: 'Yakıt, yağ, sıvılar - HALON veya CO2' },
        { icon: 'C', title: 'Sınıf C', text: 'Elektrik - CO2 veya HALON' },
        { icon: 'D', title: 'Sınıf D', text: 'Metaller - Özel kimyasal' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Elektrik yangınında ne kullanılır?',
        options: [
          { text: 'Su', isCorrect: false, feedback: '❌ Su elektrikle tehlikeli!' },
          { text: 'CO2 veya Halon', isCorrect: true, feedback: '✅ Elektriği iletmez!' },
          { text: 'Köpük', isCorrect: false, feedback: '❌ Köpük Sınıf B için' }
        ]
      }
    }
  },

  'CM-M14-U2-L3': {
    lesson_id: 'CM-M14-U2-L3',
    title: '🎮 Yangın Senaryosu',
    type: 'scenario',
    duration: 5,
    xp: 55,
    scenario: {
      question: '🔥 SENARYO: Kabin Yangını',
      context: 'Lavatoryde duman görüldü. Yangın alarmı çalıyor. Ne yaparsın?',
      options: [
        { id: 'A', text: 'Hemen kaptana haber ver', isCorrect: false },
        { id: 'B', text: 'Yangını değerlendir, söndürücüyle müdahale et, rapor et', isCorrect: true },
        { id: 'C', text: 'Yolculara bağır, panik yarat', isCorrect: false },
        { id: 'D', text: 'Bekle, belki kendiliğinden söner', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Sıra: 1) Değerlendir 2) Müdahale et 3) Rapor et (PASS tekniği ile söndür)',
        wrong: '❌ Yangına anında müdahale - beklenilmez, panik yaratılmaz!'
      },
      explanation: 'PASS: Pull (pimi çek) - Aim (hedefe doğrult) - Squeeze (sık) - Sweep (süppr)'
    }
  },

  'CM-M14-U3-L3': {
    lesson_id: 'CM-M14-U3-L3',
    title: '🎮 Basınç Kaybı Quiz',
    type: 'quiz',
    duration: 4,
    xp: 50,
    quiz: {
      questions: [
        { q: 'Ani basınç kaybında ilk ne yapılır?', options: ['Kaptana haber', 'Kendi maskeni tak', 'Yolculara yardım', 'Otur'], correct: 1 },
        { q: 'Oksijen maskesi kaç saniyede bilinç kaybını önler?', options: ['5', '15-30', '60', '120'], correct: 1 },
        { q: 'Decompression kaç tip?', options: ['1', '2', '3', '4'], correct: 2 },
        { q: 'Rapid decompression süresi?', options: ['0-1sn', '1-10sn', '10-60sn', '60+sn'], correct: 1 },
        { q: 'Time of Useful Consciousness (TUC) nedir?', options: ['Oksijensiz bilinçli kalma süresi', 'Uçuş süresi', 'Tahliye süresi', 'İniş süresi'], correct: 0 }
      ]
    }
  },

  'CM-M14-U4-L4': {
    lesson_id: 'CM-M14-U4-L4',
    title: '🎮 Tıbbi Senaryo',
    type: 'scenario',
    duration: 5,
    xp: 55,
    scenario: {
      question: '🏥 SENARYO: Bayılan Yolcu',
      context: 'Yolcu aniden bayıldı ve nefes almıyor. Ne yaparsın?',
      options: [
        { id: 'A', text: 'Doktor anons yap', isCorrect: false },
        { id: 'B', text: 'Bilinç ve solunum kontrol et, CPR başlat, AED getirt, anons yap', isCorrect: true },
        { id: 'C', text: 'Su ver, bekle', isCorrect: false },
        { id: 'D', text: 'Yere yatır, ayaklarını kaldır', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 ABC: Airway - Breathing - Circulation! Nefes yoksa CPR!',
        wrong: '❌ Nefes almayan yolcuya CPR! Doğru sıra kritik!'
      },
      explanation: 'Kardiyak arrest: 1) Bilinç kontrol 2) Solunum kontrol 3) CPR 4) AED 5) Doktor anons'
    }
  },

  // ==================== M14 EKSİK DERSLER ====================
  'CM-M14-U1-L2': {
    lesson_id: 'CM-M14-U1-L2',
    title: 'Acil Çıkış Kapıları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🚪 Acil Çıkış Kapıları',
      intro: 'Uçak tipine göre kapı sayısı değişir',
      facts: [
        { icon: '🚪', title: 'Ana Kapılar', text: 'Boarding/Deplaning kapıları' },
        { icon: '🚨', title: 'Acil Çıkışlar', text: 'Overwing exits' },
        { icon: '⚠️', title: 'Slide', text: 'Her kapıda kaydırak' },
        { icon: '🔧', title: 'Armed/Disarmed', text: 'Slide aktif/pasif' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Armed position ne demek?',
        options: [
          { text: 'Kapı kapalı', isCorrect: false, feedback: '❌ Kapalı olup olmaması farklı!' },
          { text: 'Kaydırak aktif, açılınca otomatik şişer', isCorrect: true, feedback: '✅ Uçuşta hep armed olmalı!' },
          { text: 'Kilitli', isCorrect: false, feedback: '❌ Kilit farklı konsept!' }
        ]
      }
    }
  },

  'CM-M14-U1-L3': {
    lesson_id: 'CM-M14-U1-L3',
    title: 'Güvenlik Ekipmanları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🧰 Güvenlik Ekipmanları',
      intro: 'Her uçakta bulunması gereken ekipmanlar',
      facts: [
        { icon: '🧯', title: 'Yangın Söndürücü', text: 'Halon, CO2, su' },
        { icon: '🪓', title: 'Crash Axe', text: 'Acil durum baltası' },
        { icon: '🔦', title: 'Megaphone', text: 'Anons için' },
        { icon: '💡', title: 'Flashlight', text: 'Duman/karanlıkta' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Crash axe ne için kullanılır?',
        options: [
          { text: 'Yemek kesmek', isCorrect: false, feedback: '❌ Acil ekipman!' },
          { text: 'Acil durumda panel/kapı kırmak', isCorrect: true, feedback: '✅ Yangın veya tahliyede!' },
          { text: 'Kargo açmak', isCorrect: false, feedback: '❌ Güvenlik ekipmanı!' }
        ]
      }
    }
  },

  'CM-M14-U2-L2': {
    lesson_id: 'CM-M14-U2-L2',
    title: 'Yangın Türleri',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🔥 Yangın Sınıfları',
      intro: 'Farklı yangınlara farklı müdahale',
      categories: [
        { icon: 'A', title: 'Class A', examples: 'Kağıt, kumaş', desc: 'Su ile söndür' },
        { icon: 'B', title: 'Class B', examples: 'Yakıt, yağ', desc: 'Köpük veya CO2' },
        { icon: 'C', title: 'Class C', examples: 'Elektrik', desc: 'CO2 veya Halon' },
        { icon: 'D', title: 'Class D', examples: 'Metal', desc: 'Özel powder' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Elektrik yangınına ne atılmaz?',
        options: [
          { text: 'CO2', isCorrect: false, feedback: '✓ CO2 elektrikte OK!' },
          { text: 'Su', isCorrect: true, feedback: '✅ Su elektriği iletir, tehlikeli!' },
          { text: 'Halon', isCorrect: false, feedback: '✓ Halon elektrikte OK!' }
        ]
      }
    }
  },

  'CM-M14-U3-L1': {
    lesson_id: 'CM-M14-U3-L1',
    title: 'Dekompresyon Nedir?',
    type: 'interactive',
    duration: 5,
    xp: 30,
    content: {
      title: '💨 Dekompresyon (Basınç Kaybı)',
      intro: 'Kabin basıncının ani kaybı',
      facts: [
        { icon: '💨', title: 'Ani (Explosive)', text: 'Saniyeler içinde, çok tehlikeli' },
        { icon: '🌬️', title: 'Hızlı (Rapid)', text: '1-10 saniye, tehlikeli' },
        { icon: '🍃', title: 'Yavaş (Gradual)', text: 'Dakikalar, fark edilmesi zor' },
        { icon: '😵', title: 'TUC', text: 'Time of Useful Consciousness' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'TUC ne demek?',
        options: [
          { text: 'Uçuş süresi', isCorrect: false, feedback: '❌ Flight time farklı!' },
          { text: 'Faydalı bilinç süresi', isCorrect: true, feedback: '✅ Oksijensiz kalma sınırı!' },
          { text: 'Turnaround', isCorrect: false, feedback: '❌ Yer hizmeti terimi!' }
        ]
      }
    }
  },

  'CM-M14-U3-L2': {
    lesson_id: 'CM-M14-U3-L2',
    title: 'Oksijen Sistemi',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '😷 Oksijen Maskeleri',
      intro: 'Basınç kaybında hayat kurtaran sistem',
      steps: [
        { level: 1, title: '⚠️ Maskeler Düşer', desc: 'Otomatik olarak iner' },
        { level: 2, title: '👤 KENDİNE TAK', desc: 'ÖNCE kendi maskeni tak!' },
        { level: 3, title: '👶 Sonra Yardım', desc: 'Çocuk/yardım gerektirene yardım' },
        { level: 4, title: '🪑 Otur', desc: 'En yakın koltuğa otur' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Neden önce kendi masken?',
        options: [
          { text: 'Bencillik', isCorrect: false, feedback: '❌ Güvenlik kuralı!' },
          { text: 'Bilinç kaybedersen kimseye yardım edemezsin', isCorrect: true, feedback: '✅ Önce kendin, sonra başkaları!' },
          { text: 'Hız için', isCorrect: false, feedback: '❌ Güvenlik önceliği!' }
        ]
      }
    }
  },

  'CM-M14-U4-L1': {
    lesson_id: 'CM-M14-U4-L1',
    title: 'Tahliye Nedir?',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🏃 Acil Tahliye (Evacuation)',
      intro: '90 saniyede tüm yolcuları tahliye hedefi',
      facts: [
        { icon: '⏱️', title: '90 Saniye', text: 'Sertifikasyon standardı' },
        { icon: '🚪', title: 'Yarı Kapılar', text: 'Sadece yarısı kullanılabilir varsay' },
        { icon: '🗣️', title: 'Komutlar', text: 'Net ve yüksek sesle' },
        { icon: '🚫', title: 'Eşya Yok', text: 'Bagaj bırak, hayatı kurtar' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Tahliyede yolcu eşyasını almak isterse?',
        options: [
          { text: 'İzin ver', isCorrect: false, feedback: '❌ Zaman kaybı ve tehlikeli!' },
          { text: 'Kesinlikle hayır, bırak ve çık komutu', isCorrect: true, feedback: '✅ Hayat > Eşya!' },
          { text: 'Küçükse OK', isCorrect: false, feedback: '❌ Tüm eşyalar bırakılmalı!' }
        ]
      }
    }
  },

  'CM-M14-U4-L2': {
    lesson_id: 'CM-M14-U4-L2',
    title: 'Tahliye Komutları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '📢 Tahliye Komutları',
      intro: 'Net, yüksek, tekrarlı komutlar',
      facts: [
        { icon: '🇬🇧', title: '"BRACE BRACE"', text: 'Çarpışma pozisyonu' },
        { icon: '🚪', title: '"OPEN YOUR SEATBELT"', text: 'Kemer aç' },
        { icon: '🏃', title: '"LEAVE EVERYTHING"', text: 'Eşyaları bırak' },
        { icon: '➡️', title: '"THIS WAY"', text: 'Çıkış yönü göster' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'BRACE komutu ne zaman?',
        options: [
          { text: 'Normal iniş', isCorrect: false, feedback: '❌ Normal değil, acil!' },
          { text: 'Sert iniş/çarpışma öncesi', isCorrect: true, feedback: '✅ Impact pozisyonu!' },
          { text: 'Türbülans', isCorrect: false, feedback: '❌ Türbülansta kemer yeterli!' }
        ]
      }
    }
  },

  'CM-M14-U4-L3': {
    lesson_id: 'CM-M14-U4-L3',
    title: 'Slide/Raft Kullanımı',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🛟 Slide ve Raft',
      intro: 'Kaydırak ve can salı kullanımı',
      facts: [
        { icon: '🛝', title: 'Slide', text: 'Karada tahliye kaydırağı' },
        { icon: '🛟', title: 'Slide/Raft', text: 'Suda sal olarak kullanılır' },
        { icon: '👟', title: 'Topuklu Çıkar', text: 'Slide\'ı delmemek için' },
        { icon: '🧍', title: 'Atla-Otur-Kay', text: 'Jump, sit, slide' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Slide kullanırken ne yapılmaz?',
        options: [
          { text: 'Atlamak', isCorrect: false, feedback: '✓ Atla, otur, kay!' },
          { text: 'Topuklu ayakkabı ile kaymak', isCorrect: true, feedback: '✅ Topuklu slide\'ı deler!' },
          { text: 'Oturmak', isCorrect: false, feedback: '✓ Otur ve kay!' }
        ]
      }
    }
  },

  'CM-M14-U5-L1': {
    lesson_id: 'CM-M14-U5-L1',
    title: 'İlk Yardım Temelleri',
    type: 'interactive',
    duration: 5,
    xp: 30,
    content: {
      title: '🩹 İlk Yardım',
      intro: 'Temel ilk yardım bilgisi',
      facts: [
        { icon: '🩺', title: 'First Aid Kit', text: 'Her uçakta mevcut' },
        { icon: '💊', title: 'Medical Kit', text: 'Doktor için ilaçlar' },
        { icon: '🫀', title: 'AED', text: 'Otomatik defibrilatör' },
        { icon: '📢', title: 'Doktor Anons', text: '"Is there a doctor on board?"' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Medical Kit\'i kim açabilir?',
        options: [
          { text: 'Herkes', isCorrect: false, feedback: '❌ Sadece sağlık personeli!' },
          { text: 'Sadece doktor veya sağlık personeli', isCorrect: true, feedback: '✅ Yetkili kişi gerekli!' },
          { text: 'Kaptan', isCorrect: false, feedback: '❌ Sağlık yetkisi yok!' }
        ]
      }
    }
  },

  'CM-M14-U5-L2': {
    lesson_id: 'CM-M14-U5-L2',
    title: 'CPR Temel',
    type: 'interactive',
    duration: 5,
    xp: 30,
    content: {
      title: '💓 CPR (Kalp Masajı)',
      intro: 'Cardio Pulmonary Resuscitation',
      steps: [
        { level: 1, title: '🔍 Kontrol', desc: 'Bilinç ve solunum kontrol' },
        { level: 2, title: '📢 Yardım', desc: 'AED ve yardım çağır' },
        { level: 3, title: '👐 Göğüs Bası', desc: '30 bası (5-6 cm derinlik)' },
        { level: 4, title: '💨 Solunum', desc: '2 nefes ver' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'CPR oranı?',
        options: [
          { text: '15:2', isCorrect: false, feedback: '❌ Eski standart!' },
          { text: '30:2', isCorrect: true, feedback: '✅ 30 bası, 2 nefes!' },
          { text: '50:5', isCorrect: false, feedback: '❌ Yanlış oran!' }
        ]
      }
    }
  },

  'CM-M14-U5-L3': {
    lesson_id: 'CM-M14-U5-L3',
    title: '🎮 İlk Yardım Quiz',
    type: 'quiz',
    duration: 5,
    xp: 45,
    quiz: {
      questions: [
        { q: 'CPR oranı?', options: ['15:2', '30:2', '50:2', '20:2'], correct: 1 },
        { q: 'Medical Kit\'i kim açar?', options: ['Herkes', 'Doktor', 'Kaptan', 'CC'], correct: 1 },
        { q: 'AED ne için?', options: ['Yangın', 'Kalp ritmi', 'Nefes', 'Ağrı'], correct: 1 },
        { q: 'Doktor anons İngilizce?', options: ['Need help', 'Doctor please', 'Is there a doctor', 'Medical alert'], correct: 2 }
      ]
    }
  },

  'CM-M14-U6-L1': {
    lesson_id: 'CM-M14-U6-L1',
    title: '⚡ Acil Durum Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 70,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Yangında PASS ne demek?', options: ['Pull-Aim-Squeeze-Sweep', 'Push-Arm-Stop-Save', 'Panic-Alert-Save-Stop', 'Protect-Alert-Save-Survive'], correct: 0 },
        { q: 'Elektrik yangınında?', options: ['Su', 'CO2/Halon', 'Köpük', 'Kum'], correct: 1 },
        { q: 'Ani basınç kaybında ilk?', options: ['Anons', 'Kendi masken', 'Yolcular', 'Kaptan'], correct: 1 },
        { q: 'CPR nedir?', options: ['Cardiac Pulmonary Resuscitation', 'Crew Passenger Response', 'Critical Protocol Review', 'Captain Protocol Report'], correct: 0 },
        { q: 'AED ne için?', options: ['Yangın', 'Kalp krizi', 'Alerji', 'Bayılma'], correct: 1 },
        { q: 'Tahliyede öncelik?', options: ['Eşya', 'Uçak', 'Hayat', 'Zaman'], correct: 2 }
      ]
    }
  },

  'CM-M14-U6-L2': {
    lesson_id: 'CM-M14-U6-L2',
    title: '🎮 Doğru/Yanlış: Acil',
    type: 'truefalse',
    duration: 3,
    xp: 45,
    truefalse: {
      statements: [
        { statement: 'Yangında önce kaptana haber verilir.', isTrue: false, explanation: '❌ Önce müdahale, sonra rapor!' },
        { statement: 'Basınç kaybında önce kendi maskeni tak.', isTrue: true, explanation: '✅ Kendi güvenliğin önce!' },
        { statement: 'CPR sadece doktor yapabilir.', isTrue: false, explanation: '❌ Herkes yapabilir ve yapmalı!' },
        { statement: 'Elektrik yangınına su atılır.', isTrue: false, explanation: '❌ Su elektriği iletir!' },
        { statement: 'Acil durumda hayat önceliklidir.', isTrue: true, explanation: '✅ Hayat > Uçak > Eşya > Zaman' }
      ]
    }
  }
};

export default cabinCrewContentsM13M14Interactive;
